// removed by extract-text-webpack-plugin
module.exports = {"box":"common_box_3C3ie","fraudTemplate":"common_fraudTemplate_2SMB1","leftBox":"common_leftBox_3Typc","textBox":"common_textBox_3O_mv","title":"common_title_2tiNO","subTitle":"common_subTitle_a1UHJ","leftTitle":"common_leftTitle_3AgJk","rightBox":"common_rightBox_3w3w8","analysisBox":"common_analysisBox_1qvqj","pathAnalysisArea":"common_pathAnalysisArea_1sFjY","fraudFinance":"common_fraudFinance_30PvQ","lineBar":"common_lineBar_kTHOF","linkageAnalysis":"common_linkageAnalysis_c9A5_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/financialFraudAnalysis/common.scss
// module id = 234
// module chunks = 0